"use client";
import {NeoButton} from "@/components/forms";
//import {UsersFilterConfig} from "@/data/users/filter.config";
import {Chip, Image} from "@nextui-org/react";
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";

/**
 * TODO: @selva,@surya,@arun
 * Create a Validation Schema if you have a form & inject them
 */
export const UsersFilter: React.FC<UsersFilterProps> = ({
  onSubmit,
  oldFilter,
  innerFilters
}) => {
  const {handleSubmit} = useForm();
  const [selectedFilters, setSelectedFilters] = useState<{
    [key: string]: number[];
  }>({});

  useEffect(() => {
    if (innerFilters) {
      const initialFilters: {[key: string]: number[]} = {};
      innerFilters.forEach((filter: any) => {
        initialFilters[filter.uid] =
          oldFilter?.filters?.[filter.uid] ?? filter.defaultValue ?? [];
      });
      setSelectedFilters(initialFilters);
    }
  }, [innerFilters]);

  const toggleMultiSelect = (uid: string, id: number) => {
    setSelectedFilters(prev => {
      const current = prev[uid] || [];
      const updated = current.includes(id)
        ? current.filter((item: number) => item !== id)
        : [...current, id];
      return {...prev, [uid]: updated};
    });
  };

  const onSubmitEvent = (event: any) => {
    //handle Filter functionality
    const filtersPayload = Object.fromEntries(
      Object.entries(selectedFilters).filter(
        ([, value]) => value && value.length > 0
      )
    );
    onSubmit({...event, filters: filtersPayload});
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(event => {
          onSubmitEvent(event);
        })}
      >
        <div className="flex w-[350px] flex-col gap-5 p-2">
          {/* <NeoSelect {...register("userType")} label="User Type">
            {UsersFilterConfig?.userType?.map(item => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </NeoSelect> */}
          {/* <NeoSelect {...register("userRole")} label="User Role">
            {UsersFilterConfig?.userRole?.map(item => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </NeoSelect> */}
          {/* enable for employee login */}
          {/* <NeoSelect {...register("shift")} label="Shift">
            {UsersFilterConfig?.shift?.map(item => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </NeoSelect> */}
          {innerFilters?.map((filter: any) => (
            <div key={filter.uid}>
              <h3 className="mb-2 text-sm font-semibold">{filter.label}</h3>
              <div className="flex flex-wrap gap-2">
                {filter.options.map((opt: any) => {
                  const isSelected = selectedFilters[filter.uid]?.includes(
                    opt.id
                  );
                  return (
                    <Chip
                      key={opt.id}
                      color={isSelected ? "primary" : "default"}
                      onClick={() => toggleMultiSelect(filter.uid, opt.id)}
                      className="cursor-pointer"
                    >
                      {opt.name}
                    </Chip>
                  );
                })}
              </div>
            </div>
          ))}
          <div className="w-100 flex justify-end">
            <NeoButton
              type="submit"
              color="yellow"
              className="gap-[5px] text-lg"
              startContent={
                <Image
                  className="h-5 w-5"
                  src="/icons/filter.svg"
                  alt="filter"
                />
              }
            >
              Filter
            </NeoButton>
          </div>
        </div>
      </form>
    </>
  );
};
